export default __webpack_public_path__ + "fonts/nuckle_regular-webfont.woff2";